export default __webpack_public_path__ + "static/media/help.1f0fd23b.svg";